import arraysIntersect from '../functions/arrays-intersect';

export default class ProjectFilters {
  // dom elements
  buttons;
  listItems;

  // vars
  selectedTags = 'featured';


  constructor() {}

  init() {
    // get dom elements
    this.buttons = document.getElementsByClassName('filter-button');
    this.listItems = document.getElementsByClassName('project-list-item');

    // event handlers
    const numButtons = this.buttons.length;
    for (let i = 0; i < numButtons; i++) {
      const b = this.buttons[i];
      b.addEventListener('click', this.onFilterButtonClicked.bind(this));
    }
  }

  apply() {
    const showAll = this.selectedTags === 'all';
    const numListItems = this.listItems.length;
    for (let i = 0; i < numListItems; i++) {
      const item = this.listItems[i];

      if (showAll) {
        item.dataset.visible = true;
      } else {
        const filtersIntesect = arraysIntersect(
          item.dataset.tags.split(','),
          this.selectedTags.split(',')
        );
        item.dataset.visible = filtersIntesect;
      }
    }
  }

  onFilterButtonClicked(event) {
    const button = event.target;
    const isSelected = button.dataset.selected === true || button.dataset.selected === 'true';

    // quick exit
    if (isSelected) {
      return;
    }

    // deselect all buttons
    const numButtons = this.buttons.length;
    for (let i = 0; i < numButtons; i++) {
      const b = this.buttons[i];
      b.dataset.selected = false;
    }

    // apply filters
    button.dataset.selected = true;
    this.selectedTags = button.dataset.tags;
    this.apply();
  }
}